import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';

const indexShellDisplay: IShellDisplay = {
  route: '/pages/daily-turnover-sales',
  navTitleKey: l10n('DAILY_TURNOVER_SALES.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:common-file-text-upload',
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: indexShellDisplay, multi: true },
  ],
})
export class DailyTurnoverMetadataModule {}
